import type { AiOperationalRiskLevel } from '../../types/aiOperational'
import { StatusChip, type StatusPillTone } from '../Common'

const RISK_TONES: Record<AiOperationalRiskLevel | 'UNKNOWN', StatusPillTone> = {
  LOW: 'success',
  MEDIUM: 'warning',
  HIGH: 'danger',
  RESTRICTED: 'danger',
  UNKNOWN: 'neutral',
}

export const ExecutionRiskBadge = ({ risk }: { risk: AiOperationalRiskLevel | 'UNKNOWN' }) => (
  <StatusChip
    tone={RISK_TONES[risk]}
    className={`aiExecutionRiskBadge aiExecutionRiskBadge--${risk.toLowerCase()}`}
  >
    {risk === 'UNKNOWN' ? 'Risk unknown' : `${risk.toLowerCase()} risk`}
  </StatusChip>
)
